import type { IMicroCreditTypeData } from '~/components/widget/microcredits/list/types'

export const navItems = [
  { name: 'common.about_company', link: '#about' },
  { name: 'common.credits', link: 'credits' },
  { name: 'common.deposits', link: 'deposits' },
  { name: 'common.bank_cards', link: 'cards' },
  { name: 'common.money_transfers', link: 'money-transfers' },
  { name: 'common.exchange_rates', link: 'rates' },
  { name: 'common.news', link: 'news' },
  { name: 'common.vacancies', link: 'vacancies' },
  // Always listed under "More" in the desktop row
  { name: 'common.branches', link: 'branches', inMore: true },
  { name: 'common.atms', link: 'atms', inMore: true }
]

export const microcreditsTypes: IMicroCreditTypeData[] = [
  {
    title: 'common.microfinance_companies',
    singularTitle: 'common.microfinance_company',
    url: '/microcredits/mfk',
    icon: 'mfk',
    type: 'mfk'
  },
  {
    title: 'common.microcredit_companies',
    singularTitle: 'common.microcredit_company',
    url: '/microcredits/mkk',
    icon: 'mkk',
    type: 'mkk'
  },
  {
    title: 'common.microcredit_agencies',
    singularTitle: 'common.microcredit_agency',
    url: '/microcredits/mka',
    icon: 'mka',
    type: 'mka'
  }
]
